import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
//import makeStyles from '@mui/styles/makeStyles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1.1rem 0.5rem 0rem",
  },
  selectSearch: {
    display: "flex",
    flexDirection: "column",
    width: "150px",
    marginLeft: "-13px",
    marginBottom: "-6px",
    marginTop: "0",
    marginRight: "0"
  },
  switch: {
    marginLeft: "0.5rem",
  },
  formControl: {
    fontSize: "14px",
    height: "45px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiListItemIcon-root":{
      minWidth: "0",
      marginRight: "5px",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      display: "flex",
      alignItems: "center",
    },
    "& .MuiTypography-root": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
  formControlSmall: {
    fontSize: "14px",
    height: "35px",

    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "35px",
      background: "#FFFFFF",
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "13px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 10px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
  formControlSearch: {
    fontSize: "14px",
    height: "35px",

    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "27px",
      color: "#d2d2d2",
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      fontFamily: '"Source Sans Pro",sans-serif',
      padding: "4px 32px 5px 14px;"
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "13px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 10px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    '& .MuiOutlinedInput-root fieldset': {
      borderColor: '#605f70',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
}));

export default function CustomSelectWithIcon(props) {
  const {
    inputTitle,
    selectValue,
    handleSelectValueChange,
    data,
    name,
    isRequired,
    disabled,
    formHelperText,
    variant,
    width,
    marginTop,
    multiple,
    small,
    search,
  } = props;

  const classes = useStyles();

  // const labelId = inputTitle + "-simple-select-outlined-label";
  // const id = inputTitle + "-simple-select-outlined";
  const labelId = `${name}-simple-select-outlined-label`;
  const id = `${name}-simple-select-outlined`;

  return (
    <div className={search ? classes.selectSearch : classes.select} style={{ marginTop: marginTop }}>
      {/* <text style={{ margin: "0.2rem 0rem" }}>{inputTitle}</text>{" "} */}
      <FormControl
        variant={variant || "outlined"}
        className={small ? classes.formControlSmall : search ? classes.formControlSearch : classes.formControl}
        disabled={disabled}
        style={{ width: width }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <InputLabel id={labelId}>{inputTitle}</InputLabel>
        <Select
          required={isRequired}
          labelId={labelId}
          id={id}
          name={name}
          value={selectValue}
          onChange={handleSelectValueChange}
          variant="outlined"
          label={inputTitle}
          multiple={multiple}
          MenuProps={{ disablePortal: true }}
        >
          {data?.map((obj) => (
            <MenuItem key={obj?.id} value={obj?.id} style={{ fontSize: "14px" }}>
              {
                obj?.icon ?
                  <ListItemIcon>
                    <obj.icon fontSize="small" />
                  </ListItemIcon>
                  : <></>
              }
              <ListItemText style={{ fontSize: "14px" }}>{obj?.name}</ListItemText>
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{formHelperText}</FormHelperText>
      </FormControl>
    </div>
  );
}

CustomSelectWithIcon.defaultProps = {
  isRequired: false,
  multiple: false,
  small: false,
};

CustomSelectWithIcon.propTypes = {
  isRequired: PropTypes.bool,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
  multiple: PropTypes.bool,
};
